<template>
  <div class="UserEvaluationModal">
    <el-dialog
        title="能力雷达"
        :visible.sync="visible"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
    >
      <div id="chart1" class="echarts-div">
        <VChart class="echarts" ref="chart1" autoresize></VChart>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import VChart from "vue-echarts";
import {use} from "echarts/core";
import {CanvasRenderer} from "echarts/renderers";
import {BarChart, PieChart, RadarChart} from "echarts/charts";
import {
  DataZoomComponent,
  GridComponent,
  LegendComponent, RadarComponent,
  TitleComponent,
  ToolboxComponent,
  TooltipComponent
} from "echarts/components";

use([
  CanvasRenderer,
  PieChart,
  RadarComponent,
  RadarChart,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
  BarChart,
  ToolboxComponent,
  DataZoomComponent,
]);
export default {
  name: "UserEvaluationModal",
  props: {},
  components: {VChart},
  mixins: [],
  data() {
    return {
      chart1: {},
      tagList: [],
      data: {},
      visible: false
    };
  },
  computed: {},
  mounted() {
  },
  methods: {
    refreshChart() {
      let option = this.getDefaultOption();
      this.$refs.chart1.clear();
      this.$refs.chart1.setOption(option);
    },
    getDefaultOption() {
      let indicator = this.tagList.map(item => {
        return {
          name: item.tagName, max: 100,
        }
      })
      indicator[0].axisLabel = {
        show: true,
        fontSize: 12,
      }
      let value = this.tagList.map(item => this.data.data[item.tagId]?.toFixed(1))
      return {
        title: {
          text: this.data.username + "能力图"
        },
        radar: {
          // shape: 'circle',
          splitNumber: 4,
          indicator: indicator,
        },
        tooltip: {
          show: true,
          trigger: 'item',
          renderMode: "richText",
          confine: "true"
        },
        series: [
          {
            type: 'radar',
            areaStyle: {},
            data: [{
              value: value,
              name: "能力分值表",
              label: {
                show: false,
                formatter: function (params) {
                  return params.value;
                },
                width: 8,
                height: 8,
              },
              select: {
                label: {
                  show: true,
                  formatter: function (params) {
                    return params.value;
                  },
                  width: 8,
                  height: 8,
                },
              },
              selectedMode: "multiple"
            }]
          }
        ]
      }
    },
    initData(tagList, data) {
      this.data = {...data};
      this.tagList = [...tagList];
      this.$nextTick(() => {
        this.refreshChart();
      })
    }
  }
}
;
</script>

<style lang="scss" scoped>
.UserEvaluationModal {
  width: 100%;

  .echarts-div {
    height: 500px;
  }

  .echarts {
    height: 500px;
  }
}
</style>
